module.exports = __webpack_public_path__ + "static/carousel-00003-cad0d356fd6c81b3ea47c2109f069536.jpg";